import { Box, Stack, styled } from '@mui/material'

export const CustomTooltipContainer = styled(Stack)(
  ({ theme }) => `
		gap: ${theme.spacing(0.5)};
		padding: ${theme.spacing(1, 2)};
		background-color: hsla(0,0%,100%,0.8);
		backdrop-filter: blur(4px);
		font-size: 12px;
		border-radius: 8px;
		border: 1px solid ${theme.palette.grey['300']};
		box-shadow: 0px 16px 24px -8px rgba(0, 0, 0, 0.16);
		color: ${theme.palette.grey['800']};
	`,
)

export const CTLine = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`

export const CTColor = styled(Box)(({ color }) => {
  return `
    height: 8px;
    width: 8px;
    border-radius: 4px;
    background-color: ${color};
  `
})

export const CTTitle = styled(Box)`
  font-size: 12px;
  font-weight: 500;
`

export const CTData = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  gap: 16px;
`

export const AUContainer = styled(Box)(({ theme }) => {
  return `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `
})
